module.exports = __webpack_public_path__ + "img/shouqi.c311ce52.png";